// extracted by mini-css-extract-plugin
export default {"container":"AddFriend_container__Td437","main":"AddFriend_main__6-A-x","rowItemBox":"AddFriend_rowItemBox__-w8zT","loadingBox":"AddFriend_loadingBox__yTgkd"};